
import { mapGetters } from 'vuex'
import Button from '~/components/buttons/Button'
export default {
  components: { Button },
  props: {
    contentItem: {
      type: Object,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    loyaltyCustomer: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    opened: false,
    showAlert: false,
  }),
  computed: {
    ...mapGetters({
      vxCustomer: 'customer/getCustomer',
    }),
  },
  methods: {
    save(link) {
      window.navigator.clipboard.writeText(link)
      // alert('Copied the text: ' + link)
      this.showAlert = true
    },
  },
}
